import React, { useState } from 'react';
import { mockMembers, formatCurrency } from '../../../services/mockData';

const OpeningBalances = () => {
  const [filter, setFilter] = useState('Both');

  const totalPrincipal = mockMembers.reduce((s, m) => s + m.principal, 0);
  const totalGST = mockMembers.reduce((s, m) => s + m.gst, 0);
  const totalInterest = mockMembers.reduce((s, m) => s + m.interest, 0);
  const totalTotal = mockMembers.reduce((s, m) => s + m.total, 0);

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="breadcrumb">Members Reports <span>/ Opening Balances</span></div>
        <h2>Members Opening Balance</h2>
      </div>

      <div className="filter-bar">
        <div className="form-group">
          <label>Type</label>
          <div style={{ display: 'flex', gap: '16px', alignItems: 'center', paddingTop: '4px' }}>
            {['Outstanding', 'Advances', 'Both'].map(opt => (
              <label key={opt} style={{ display: 'flex', gap: '4px', alignItems: 'center', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
                <input type="radio" name="filter" checked={filter === opt} onChange={() => setFilter(opt)} />
                {opt}
              </label>
            ))}
          </div>
        </div>
        <div className="form-group" style={{ marginLeft: 'auto', justifyContent: 'flex-end' }}>
          <div className="btn-group">
            <button className="btn btn-warning btn-sm">🖨️ Print / Save as PDF</button>
            <button className="btn btn-success btn-sm">📊 Export To Excel</button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="report-header">
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>Members Regular Opening Balances: 2025-2026</p>
        </div>

        {/* Wing A */}
        <div className="section-title" style={{ marginBottom: '10px', marginTop: '16px' }}>Building: bhoomi — Wing: A</div>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Flat No.</th>
                <th>Member Name</th>
                <th className="amount">Principal</th>
                <th className="amount">GST</th>
                <th className="amount">Interest</th>
                <th className="amount">Total</th>
              </tr>
            </thead>
            <tbody>
              {mockMembers.filter(m => m.wing === 'A').map((m, i) => (
                <tr key={i}>
                  <td><span className="badge badge-primary">{m.flatNo}</span></td>
                  <td>{m.memberName}</td>
                  <td className={`amount ${m.principal < 0 ? 'dr' : 'cr'}`}>{formatCurrency(m.principal)}</td>
                  <td className="amount">{formatCurrency(m.gst)}</td>
                  <td className="amount cr">{formatCurrency(m.interest)}</td>
                  <td className={`amount ${m.total < 0 ? 'dr' : ''}`} style={{ fontWeight: '700' }}>
                    {m.total < 0 ? '-' : ''}{formatCurrency(Math.abs(m.total))}
                  </td>
                </tr>
              ))}
              <tr style={{ background: '#f0f4ff', fontWeight: '800' }}>
                <td colSpan={2}><b>Sub Total Wing A</b></td>
                <td className="amount dr">{formatCurrency(mockMembers.filter(m => m.wing === 'A').reduce((s, m) => s + m.principal, 0))}</td>
                <td className="amount">{formatCurrency(mockMembers.filter(m => m.wing === 'A').reduce((s, m) => s + m.gst, 0))}</td>
                <td className="amount cr">{formatCurrency(mockMembers.filter(m => m.wing === 'A').reduce((s, m) => s + m.interest, 0))}</td>
                <td className="amount">{formatCurrency(mockMembers.filter(m => m.wing === 'A').reduce((s, m) => s + m.total, 0))}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Wing B */}
        <div className="section-title" style={{ marginBottom: '10px', marginTop: '20px' }}>Building: bhoomi — Wing: B</div>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Flat No.</th>
                <th>Member Name</th>
                <th className="amount">Principal</th>
                <th className="amount">GST</th>
                <th className="amount">Interest</th>
                <th className="amount">Total</th>
              </tr>
            </thead>
            <tbody>
              {mockMembers.filter(m => m.wing === 'B').map((m, i) => (
                <tr key={i}>
                  <td><span className="badge badge-primary">{m.flatNo}</span></td>
                  <td>{m.memberName}</td>
                  <td className="amount cr">{formatCurrency(m.principal)}</td>
                  <td className="amount">{formatCurrency(m.gst)}</td>
                  <td className="amount cr">{formatCurrency(m.interest)}</td>
                  <td className="amount" style={{ fontWeight: '700' }}>{formatCurrency(m.total)}</td>
                </tr>
              ))}
              <tr style={{ background: '#f0f4ff', fontWeight: '800' }}>
                <td colSpan={2}><b>Sub Total Wing B</b></td>
                <td className="amount cr">{formatCurrency(mockMembers.filter(m => m.wing === 'B').reduce((s, m) => s + m.principal, 0))}</td>
                <td className="amount">{formatCurrency(mockMembers.filter(m => m.wing === 'B').reduce((s, m) => s + m.gst, 0))}</td>
                <td className="amount cr">{formatCurrency(mockMembers.filter(m => m.wing === 'B').reduce((s, m) => s + m.interest, 0))}</td>
                <td className="amount">{formatCurrency(mockMembers.filter(m => m.wing === 'B').reduce((s, m) => s + m.total, 0))}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Grand Total */}
        <div style={{ marginTop: '20px', padding: '14px 16px', background: 'var(--sidebar-bg)', borderRadius: '8px', color: 'white', display: 'flex', gap: '20px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <span style={{ fontWeight: '700' }}>Grand Total</span>
          <span>Principal: <b style={{ color: '#ff9f9f' }}>{formatCurrency(Math.abs(totalPrincipal))}</b></span>
          <span>GST: <b style={{ color: '#7bffdd' }}>{formatCurrency(totalGST)}</b></span>
          <span>Interest: <b style={{ color: '#7bffdd' }}>{formatCurrency(totalInterest)}</b></span>
          <span>Total: <b style={{ color: '#fff', fontSize: '16px' }}>{formatCurrency(Math.abs(totalTotal))}</b></span>
        </div>
      </div>
    </div>
  );
};

export default OpeningBalances;
